import { useState } from 'react';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

const IsMyRouterFits = (): JSX.Element => {
    const [isOpen, changePopupState] = useState(false);

    const handleClosePopup = () => {
        changePopupState(false);
    };

    const handleOpenPopup = () => {
        changePopupState(true);
    };

    return (
        <>
            <ControlElement type={'medium'} Icon={InfoCircleFlip} onClick={handleOpenPopup}>Подходит ли мне мой роутер?</ControlElement>

            <DefaultPopup isOpen={isOpen} onClose={handleClosePopup}>
                <IndentContainer $desktop={[32]} $mobile={[24]}>
                    <TextWrapper>
                        <H3 style={{ marginRight: 45 }}>Подходит ли мой роутер?</H3>
                        <Paragraph4 $color={COLORS.TextInfo} as={'ol'}>
                            <li>1. Устройство должно работать в&nbsp;двух диапазонах&nbsp;&mdash; 2,4 и&nbsp;5&nbsp;ГГц.</li>
                            <li>2. Поддерживать стандарт Wi-Fi 5&nbsp;или новее.</li>
                            <li>3. Иметь порты WAN и&nbsp;LAN с&nbsp;пропускной способностью 1&nbsp;Гбит/c.</li>
                        </Paragraph4>
                    </TextWrapper>

                    <ButtonGroup>
                        <Button bType={'action'} size={'large'} onClick={handleClosePopup}>Закрыть</Button>
                    </ButtonGroup>
                </IndentContainer>
            </DefaultPopup>
        </>
    );
};

export default IsMyRouterFits;
